export enum CertificateStatus {
  ACTIVE = 'ACTIVE',
  NEW = 'NEW',
  USED = 'USED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED'
}
